import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Proxy} from '../../types/proxy';
import {Attachment} from "../../types/attachment";
import {HttpEventType} from "@angular/common/http";
import {Subscription} from "rxjs";
import {AttachmentType} from "../../types/attachment-type";
import {FormService} from "../../services/form.service";
import {MessageService} from "primeng/api";
import {FileUpload} from "primeng/fileupload";
import {Constants} from "../../types/constants";

type AttachmentInternal = {
  attachment ?: Attachment,
  subscription ?: Subscription
}

@Component({
  selector: 'assignee',
  templateUrl: './assignee.component.html',
  styleUrls: ['./assignee.component.css']
})
export class AssigneeComponent implements OnInit {
  @Input() docId !: number;
  @Output() assigneeChange = new EventEmitter<boolean>();
  @Output() proxyChange = new EventEmitter<Proxy>();
  @Output() authFileChange = new EventEmitter<Attachment>();
  @Output() authPaymentFileChange = new EventEmitter<Attachment>();
  @ViewChild('assigneeForm') assigneeForm!: NgForm;
  @ViewChild('af') authFileUpload!: FileUpload;
  @ViewChild('authPayFile') authPayFileUpload!: FileUpload;

  AttachmentType = AttachmentType;

  proxy : Proxy = {};
  isAssignee : boolean = false;
  assigneeFormDirty : boolean = false;
  authFile ?: AttachmentInternal = undefined;
  authPaymentFile ?: AttachmentInternal = undefined;

  constructor(private formService: FormService,
              private messageService: MessageService) {}

  ngOnInit(): void {
    this.proxy = {};
    this.isAssignee = false;
    this.assigneeFormDirty = false;
    this.authFile = undefined;
    this.authPaymentFile = undefined;
  }

  hasAssigneeChanged(checked: boolean) : void {
    if (!checked) {
      this.assigneeForm.form.reset();
      this.assigneeFormDirty = false;
      this.proxy = {};
      if (this.authFile)
        this.fileRemove(AttachmentType.AUTHORIZATION, this.authFileUpload);
      if (this.authPaymentFile)
        this.fileRemove(AttachmentType.AUTH_PAYMENT, this.authPayFileUpload);
    }
    this.assigneeChange.emit(checked);
    this.proxyChange.emit(this.proxy);
  }

  editFormInvalid() : boolean {
    if (this.isAssignee) {
      if (this.assigneeForm != undefined) {
        let controls = this.assigneeForm.form.controls;
        for (let key in controls) {
          let control = controls[key];
          if (control.invalid && (control.touched || control.dirty))
            return true;
        }
      }

      if (this.assigneeFormDirty &&
          (this.authFile == undefined || this.authPaymentFile == undefined)) {
        return true;
      }
    }
    return false;
  }

  formInvalid() : boolean {
    if (this.assigneeForm?.invalid
      || (this.isAssignee && (this.authFile == undefined || this.authPaymentFile == undefined)))
      return true;
    return false
  }

  updateAttachment(attachmentType: AttachmentType, attachmentInternal ?: AttachmentInternal) {
    if (attachmentType == AttachmentType.AUTHORIZATION) {
      this.authFile = attachmentInternal;
      this.authFileChange.emit(attachmentInternal?.attachment);
    } else {
      this.authPaymentFile = attachmentInternal;
      this.authPaymentFileChange.emit(attachmentInternal?.attachment);
    }
  }

  uploadHandler(event: any, fileUpload: FileUpload, attachmentType: AttachmentType) {
    if (event.files[0] == undefined)
      return;
    if (!this.proxy.firstname) {
      this.messageService.add({
        severity:'warn',
        detail: "Najpierw podaj imię" }
      );
      fileUpload.clear();
      return;
    }
    if (!this.proxy.surname) {
      this.messageService.add({
        severity:'warn',
        detail: "Najpierw podaj nazwisko" }
      );
      fileUpload.clear();
      return;
    }
    let attachment: Attachment = {name: event.files[0].name, id: 0};
    let attachmentInternal: AttachmentInternal = {attachment: attachment};
    this.updateAttachment(attachmentType, attachmentInternal);
    fileUpload.disabled = true;
    fileUpload.progress = 0;

    this.formService.uploadFile(event.files[0], this.docId, attachmentType, this.proxy.firstname, this.proxy.surname)
      .subscribe(
        event => {
          if (event.type === HttpEventType.UploadProgress) {
            fileUpload.progress = Math.round(100 * (event.loaded / event.total));
            fileUpload.cd.markForCheck();
          }
          if (event.type === HttpEventType.Response) {
            attachment.id = Number(event.body.message);
            this.updateAttachment(attachmentType, attachmentInternal);
          }
        },
        error => {
          this.messageService.add({
            severity: (error.status == 400 && error.error.message != Constants.GenericError) ? 'warn' : 'error',
            detail: error.error.message ?? Constants.GenericError}
          );
          fileUpload.clear();
          fileUpload.uploadedFileCount = 0;
          fileUpload.disabled = false;
          this.updateAttachment(attachmentType, undefined);
        }
      );
  }

  fileRemove(attachmentType: AttachmentType, fileUpload: FileUpload) {
    this.updateAttachment(attachmentType, undefined);
    fileUpload.uploadedFileCount = 0;
    fileUpload.progress = 0;
    fileUpload.disabled = false;
  }

  setFormDirty(dirty : boolean) {
    this.assigneeFormDirty = dirty;
  }

  markFormAsTouched() : void {
    this.assigneeForm.form.markAllAsTouched();
  }
}
